import { createContext, useReducer } from "react";

export const UnContext = createContext();

export const unReducer = (state, action) => {
    switch (action.type) {
        case 'SET_UN':
            return {
                un: action.payload
            }
        case 'CREATE_UN':
            return {
                un: [action.payload, ...state.un]
            }
        case 'DELETE_UN':
            return {
                un: state.un.filter(a => a._id !== action.payload._id)
            }
        default:
            return state
    };
};

export const UnContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(unReducer, {
        un: null
    });

    return (
        <UnContext.Provider value={{ ...state, dispatch }}>
            {children}
        </UnContext.Provider>
    );
};